import { ServiceConfiguration } from './service.model';
import { Address } from './address.model';
import { Phone } from './phone.model';
import { ID } from './ID.model';
import { CategoryV2 } from '../components/generics/data-printer-v2/data-printer-v2.component';

export interface Office {
    clave?: string;
    activo?: boolean;
    apellidoResponsable: string;
    celular: Phone;
    cuit: string;
    direccion: Address;
    email: string;
    fechaActualizacion?: string;
    fechaCreacion?: string;
    id?: ID;
    nombreResponsable: string;
    sucursal: string;
    telefonoFijo: Phone;
    nombre: string;
    servicios?: ServiceConfiguration[];
    idRemax: string;
}

export function generateOfficeCategories(office?: Office) {
    if (!office) return [];

    const categories: CategoryV2[] = [];

    categories.push({
        labelWidth: '95px',
        maxWidth: '450px',
        name: 'Información general',
        items: [
            { label: 'Nombre', value: office.nombre },
            { label: 'Nro. sucursal', value: office.sucursal },
            { label: 'Teléfono', value: office.telefonoFijo, type: 'phone' },
            { label: 'CUIT', value: office.cuit, type: 'cuit' },
            { label: 'ID de oficina Remax', value: office.idRemax },
        ]
    }, {
        maxWidth: '500px',
        name: 'Dirección',
        items: [
            { value: office.direccion, type: 'address', alignment: 'center' },
        ]
    }, {
        labelWidth: '65px',
        maxWidth: '450px',
        name: 'Responsable',
        items: [
            { label: 'Nombre', value: office.nombreResponsable },
            { label: 'Apellido', value: office.apellidoResponsable },
            { label: 'Teléfono', value: office.celular, type: 'phone' },
            { label: 'Email', value: office.email, type: 'email' },
        ]
    });

    return categories;
}
